import { render, staticRenderFns } from "./LiveOddsHeader.vue?vue&type=template&id=1e42b493&"
import script from "./LiveOddsHeader.vue?vue&type=script&lang=js&"
export * from "./LiveOddsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports